import "../styles/HomeNew.css";

const BOARD = [
  {
    name: "Akhila Vedam",
    image: "/images/board-committees/AkhilaVedam.jpg",
    role: "STEAM Olympics Co-Chair",
    color: "lchip--purple",
    bio: "Akhila Vedam has been a resident of Bloomington-Normal, IL, for the past 12 years and works as a Program Manager at Caterpillar Inc. She is deeply passionate about volunteering for initiatives that help youth in the community gain valuable social service experience while developing leadership abilities. Currently, Akhila serves as a Co-Chair for the STEAM Olympics and as one of the leads for the Youth Volunteer Corps committee at FBT. She has also volunteered at Kite Fest for the past few years, often alongside her children. Akhila and her husband, Venkat, are proud parents of Aditi and Abhinav. Together, they enjoy spending time outdoors, hiking, and camping during the summer. Akhila also loves to travel to new places, seeking fresh experiences and perspectives on different cultures.",
  },
  {
    name: "Christine Holmes",
    image: "/images/board-committees/ChristineHolmes.jpg",
    role: "Project Recruitment",
    color: "lchip--green",
    bio: "Christine is passionate about supporting small nonprofits in the U.S. and abroad to achieve meaningful, community-driven impact. A former Peace Corps volunteer in West Africa, Christine gained firsthand experience in grassroots development and collaboration. Professionally, Christine has worked for federal and state agencies that provide grants to nonprofits, gaining unique insight into funding processes and partnerships. Additionally, Christine has served in various roles within nonprofits, including her current position as an Impact and Learning Manager, where she focuses on evaluating and enhancing organizational effectiveness. Christine is dedicated to helping nonprofits thrive and create sustainable change.",
  },
  {
    name: "Claire Campbell",
    image: "/images/board-committees/ClaireCampbell.jpg",
    role: "Project Recruitment Chair",
    color: "lchip--pink",
    bio: "Claire Campbell attends ISU to study physics. She is a graduate of the 2022 YGC class and was a recipient of a 2022 YICU award. Claire has previously worked with several local non-profits to raise awareness about and funds for their causes.",
  },
  {
    name: "Hariharan Senthilnathan",
    image: "/images/board-committees/Hari.jpg",
    role: "Marketing & STEAM Olympics Committees",
    color: "lchip--green",
    bio: "Hariharan Senthilnathan has been a wonderful addition to the FBT family. Hari currently chairs the Marketing and Technology Committee and also serves as the FBT Board Secretary. What the organization values about Hari is that he not only volunteers for critical needs, but he also consistently follows through on the commitments he makes.",
  },
  {
    name: "Kathy Weinzierl",
    image: "/images/board-committees/Kathy.jpg",
    role: "YICU Chair",
    color: "lchip--purple",
    bio: "Kathy Weinzierl is in her second year on the FBT Board and her third year helping with YICU. She has been a substitute teacher for Olympia Elementary Schools for about 20 years. Kathy has three grown daughters—Gracie, Hannah, and Claire—all of whom work professionally in the agriculture field. Her husband, Rod, works for Illinois Corn and farms as well. Kathy has been a 4-H leader for the Olympia Pacesetters 4-H Club based in Stanford since 2001. The club has over 40 members and focuses on service learning.The club has established a food pantry, community garden, and Emergency Mini Food Pantry project.Members are working to place an Emergency Mini Food Pantry in all nine communities in the school district and at the high school complex, thanks to a $25,000 State Farm Neighborhood Assist grant. The club continues to find ways to combat hunger in rural communities.The youth are always eager to serve others, which is the main reason Kathy decided to be involved with FBT.The missions are very parallel. She appreciates recognizing youth—our future leaders—for what they are doing now.They are amazing and inspiring.",
  },
  {
    name: "Phani Aytam",
    image: "/images/board-committees/Phani.jpg",
    role: "Finance Committee",
    color: "lchip--green",
    bio: "Phani Aytam and his wife, Sandeepa, are proud parents of their daughters, Shree and Haasini. They consider themselves blessed to work for a great organization like State Farm, live in a wonderful and giving community like McLean County, and serve alongside amazing individuals they are fortunate to call friends. Phani believes in the power of community—a thoughtful collective with boundless hope, shared values, and a unifying purpose.He has served alongside several inspiring leaders on purposeful boards such as the Multicultural Leadership Program, For A Better Tomorrow, and United Way, to name a few.Whether promoting social entrepreneurship, building stronger communities, or fostering leadership diversity, the common thread in Phani’s involvement is rooted in servant leadership and social justice.",
  },
  {
    name: "Rahul Varun Balivada",
    image: "/images/board-committees/Rahul.jpg",
    role: "Technology Committee",
    color: "lchip--purple",
    bio: "Rahul Varun Balivada and his wife, Chaitanya, have two young daughters, Sahasra and Poorvika, who always keep them busy. They have lived in Bloomington since 2011 and find it an amazing place to live and learn. Rahul joined FBT’s Technology Committee in 2020 and is proud to contribute to an organization that has been brightening lives by working with organizations locally and globally.",
  },
  {
    name: "Raja Ayyapusetty",
    image: "/images/board-committees/Raja.jpg",
    role: "Board Treasurer",
    color: "lchip--pink",
    bio: "Raja Ayyapusetty has been an invaluable addition to the FBT family since 2020. Raja joined a depleted volunteer board with a wonderful attitude. As a longtime donor who has supported numerous FBT efforts, he stepped in to support immediate needs. He provided technical support to host the large virtual gathering for the 2020 YICU Service Awards. He was also recently elected as the FBT Board Treasurer. Raja serves on the Finance Committee and assists in maturing the organization’s Giving Committee efforts. Raja’s unwavering commitment to FBT and passion for serving others are greatly appreciated.",
  },
  {
    name: "Sambasivarao Gurijala",
    image: "/images/board-committees/Sam-G.jpg",
    role: "Board Chair",
    color: "lchip--green",
    bio: "Sambasivarao (Sam) Gurijala works as a Senior Data Engineer Consultant in Bloomington-Normal, IL, and has worked in Information Technology for the past 22 years. As a resident of Bloomington-Normal for the past 14 years, he has worked with numerous non-profits in and out of town. Sam served as an Executive Board Member for MCIA – McLean County India Association, an Executive Board Member and Program Coordinator for TAB – Telugu Association of Bloomington, a Steering Committee member for the HSS International Yoga Festival, and an active lead coordinator for Kite Fest. Sam enjoys serving and assisting with efforts for the betterment of the community. His family includes his supportive wife, Sirisha, their 14-year-old son Shriyans, and their 11-year-old daughter Srinidhi. Sam enjoys listening to music and going on long road trips. His longest single stretch of driving has been from Atlanta to Washington, D.C. His dream place to visit is Key West, which he hopes to visit soon.",
  },
  {
    name: "Shloka Ravinuthala",
    image: "/images/board-committees/ShlokaRavinuthala.jpg",
    role: "YGC Committee",
    color: "lchip--purple",
    bio: "Shloka Ravinuthala attends Wright State University. She enjoys listening to all types of music and watching Indian films with her family and close friends. She has been part of the workforce since she was 15 and currently serves as a Human Relations Intern with the Town of Normal. After joining YGC, she quickly realized the immense potential FBT could have in her life. Her mission is to inspire kids to get involved in their community and to help them realize that their voices can be impactful. Her ultimate goal is to become a doctor.",
  },
  {
    name: "Siddhi Hindurao",
    image: "/images/board-committees/SiddhiHindurao.jpg",
    role: "YGC Committee Chair",
    color: "lchip--pink",
    bio: "Siddhi Hindurao attends University of Chicago. She plans to major in neuroscience on a pre-med track. She is also a swim instructor at Swim America. In her free time, she enjoys reading and playing the violin.",
  },
  {
    name: "Vasudha Gadhiraju",
    image: "/images/board-committees/VasudhaPinnamaraju.jpg",
    role: "Project Recruitment",
    color: "lchip--green",
    bio: "Vasudha Gadhiraju has served as Director of Innovation and Technology for the Town of Normal since 2019. In this role, she provides vision and thought leadership for the town’s smart city and innovation efforts while managing the day-to-day operations of its technology department. Prior to joining the Town of Normal, Gadhiraju served as Executive Director of the McLean County Regional Planning Commission (MCRPC), where she led several award-winning long-range planning efforts for Bloomington, Normal, and McLean County. Before joining MCRPC, she served the City of Decatur in various roles in community and economic development, neighborhood planning, and geographic information systems.",
  },
  {
    name: "Venkateswara Mandava",
    image: "/images/board-committees/Mandava.jpg",
    role: "Kite Fest Co-Chair",
    color: "lchip--purple",
    bio: "Venkateswara Mandava is known as a people’s person and is popularly known as Mandava in Bloomington-Normal. He is a founding member of FBT and has served in various roles including Treasurer, Fundraising Committee member, and Director of Kite Fest. He is a servant leader in the community where he lives. He has served as Chair of the Normal Human Relations Commission, Minority and Police Partnership (MAPP), and President of the McLean County India Association (MCIA). Currently, he serves as a trustee on the Bloomington-Normal Connect Transit Board. He has over 35 years of global leadership experience across diversified industries and brings a wealth of experience in service, IT, marketing, and industrial management. He possesses strong leadership, facilitation, coordination, and communication skills and believes in hard work and dedication. He has grown children—Bhavita (daughter) and Manish (son)—who completed their education in medicine and are now serving others.",
  },
];

function BoardCard({ member }) {
  const accentColor =
    member.color === "lchip--purple" ? "var(--pu-500)"
      : member.color === "lchip--pink" ? "var(--pk-500)"
        : "var(--gn-500)";

  const bgColor =
    member.color === "lchip--purple" ? "var(--pu-50)"
      : member.color === "lchip--pink" ? "var(--pk-50)"
        : "var(--gn-50)";

  const borderColor =
    member.color === "lchip--purple" ? "var(--pu-200)"
      : member.color === "lchip--pink" ? "var(--pk-200)"
        : "var(--gn-200)";

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "auto 1fr",
      gap: "1.5rem",
      alignItems: "flex-start",
      background: "var(--white)",
      border: `1.5px solid var(--bdr)`,
      borderRadius: "18px",
      padding: "1.6rem",
      transition: "border-color .2s, box-shadow .2s, transform .2s",
    }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = borderColor;
        e.currentTarget.style.boxShadow = `0 8px 32px rgba(0,0,0,.07)`;
        e.currentTarget.style.transform = "translateY(-3px)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "var(--bdr)";
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {/* Avatar */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: ".6rem" }}>
        <div style={{
          width: "88px",
          height: "88px",
          borderRadius: "50%",
          overflow: "hidden",
          border: `3px solid ${borderColor}`,
          flexShrink: 0,
          background: "var(--bdr)",
        }}>
          <img
            src={member.image}
            alt={member.name}
            width={88}
            height={88}
            loading="lazy"
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            onError={e => {
              e.target.style.display = "none";
              e.target.parentElement.style.background = bgColor;
            }}
          />
        </div>
        {/* Color dot */}
        <span style={{
          width: 8, height: 8,
          borderRadius: "50%",
          background: accentColor,
          boxShadow: `0 0 6px ${accentColor}`,
          display: "block",
        }} />
      </div>

      {/* Text */}
      <div style={{ display: "flex", flexDirection: "column", gap: ".45rem" }}>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: ".5rem" }}>
          <h3 style={{
            fontFamily: "var(--ff-head)",
            fontSize: "1.05rem",
            fontWeight: 800,
            color: "var(--ink)",
            lineHeight: 1.2,
          }}>
            {member.name}
          </h3>
          <span className={`lcard__chip ${member.color}`} style={{ fontSize: ".62rem" }}>
            {member.role.split(" · ")[0]}
          </span>
        </div>

        {member.role.includes(" · ") && (
          <p style={{ fontSize: ".7rem", fontWeight: 700, color: "var(--lt)", letterSpacing: ".05em", textTransform: "uppercase" }}>
            {member.role.split(" · ").slice(1).join(" · ")}
          </p>
        )}

        <p style={{
          fontSize: ".84rem",
          color: "var(--muted)",
          lineHeight: 1.75,
          marginTop: ".1rem",
        }}>
          {member.bio}
        </p>
      </div>
    </div>
  );
}

export default function Board() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "40svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Board of<br />
              <span className="hero__accent">Directors</span>
            </h1>
            <p className="hero__sub">
              Meet the dedicated volunteers who guide FBT's mission — connecting
              local generosity to global impact, one community at a time.
            </p>
            <div className="hero__ctas">
              <a href="https://www.forbettertomorrow.org/about/" className="cta cta--solid">Our Mission</a>
              <a href="#members" className="cta cta--ghost">Meet the Board ↓</a>
            </div>
          </div>

          {/* Stats */}
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">{BOARD.length}</span>
              <span className="hstat__l">Board Members</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">100%</span>
              <span className="hstat__l">Volunteers</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">IL</span>
              <span className="hstat__l">Based in Illinois</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── BOARD MEMBERS ── */}
      <section id="members" className="local" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Leadership</span>
          <h2 className="sec-h2">Meet Our Board</h2>
          <p className="sec-sub">
            Our board members bring diverse backgrounds and a shared commitment to
            service, philanthropy, and community leadership.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "1.1rem" }}>
          {BOARD.map(member => (
            <BoardCard key={member.name} member={member} />
          ))}
        </div>
      </section>

    </div>
  );
}